import {prependRoot} from "../util/prependRoot.js";
import {getApiRoot} from "../store/configureStore.js";
import axios from "axios";

const routePrefix = "/simulatieinfrastructuur/";

const SimulatieInfrastructuurApi = {
	getAllByDossierId(dossierId) {
		const serviceUrl = prependRoot(routePrefix + "dossier/" + dossierId, getApiRoot());
		return axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
	}
};

export default SimulatieInfrastructuurApi;
